
<template>
  <div>
    <div class="commonBox projectBox">
      <div class="searchLine">
         <!-- 搜索框 -->
         <form action="">
          <van-search v-model="keywords" shape="round" background="transparent" placeholder="搜索姓名" @search="onSearch" />
         </form>
         <div class="showNum">
          {{allNum}}笔 | <span class="colorNum">{{totalMoney}}元</span>
        </div>
      </div>
      <div class="tabBox">
        <div :class="activeTab==item.id?'tabItem activeTab':'tabItem'" v-for="(item,i) in tabList" :key="i" @click="changeTab(item.id)">{{item.name}}</div>
      </div>
     
    </div>
    <!-- 全部项目列表 -->
    <div class="listBox">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <ul class="projectList">
            <li class="projectItem" v-for="(item,i) in list" :key="i">
              <div class="projectDetail">
                <div class="imgBox">
                  <img :src="item.avatar?item.avatar:defaultImage" class="coverImg">
                </div>
                <div class="contentBox">
                  <div class="itemTitle">{{item.name }}</div>
                  <div class="itemDis">捐赠{{item.wupin?(item.wupin+','):''}}{{item.money?('金额'+item.money+'元'):''}}</div>
                </div>
                <div class="timeBox">{{item.donate_date}}</div>
              </div>
            </li>
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- 线下捐赠提交入口 -->
    <div class="submitBar">
      <div class="submitBarBtn" @click="openForm">线下捐赠提交</div>
    </div>

    <!-- 线下捐赠提交弹窗 -->
    <van-popup v-model="showForm" position="bottom" round :style="{ height: '88%' }" :close-on-click-overlay="false">
      <div class="formPopup">
        <div class="popupHeader">
          <span class="popupTitle">线下捐赠提交</span>
          <van-icon name="cross" class="popupClose" @click="closeForm(false)" />
        </div>

        <div class="popupBody">
          <!-- 捐赠金额 -->
          <div class="formItem">
            <van-field
              v-model="form.money"
              label="捐赠金额"
              placeholder="请输入捐赠金额"
              type="number"
              maxlength="10"
              required
            />
          </div>
          <!-- 身份 -->
          <div class="formItem">
            <van-field
              readonly
              clickable
              required
              label="身份"
              :value="form.identity"
              placeholder="选择身份"
              @click="showIdentityPicker = true"
            />
            <van-popup v-model="showIdentityPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="indentityList"
                @cancel="showIdentityPicker = false"
                @confirm="chooseIdentity"
              />
            </van-popup>
          </div>
          <!-- 姓名 -->
          <div class="formItem">
            <van-field
              v-model="form.name"
              label="姓名(或团体)"
              placeholder="请输入姓名"
              maxlength="15"
              required
            />
          </div>
          <!-- 性别 -->
          <div class="formItem sexItem" v-if="addFields.sex">
            <div class="itemLabel sexLabel">性别</div>
            <van-radio-group v-model="form.sex" direction="horizontal">
              <van-radio name="男" checked-color="#b8211a" icon-size="30rem">男</van-radio>
              <van-radio name="女" checked-color="#b8211a" icon-size="30rem">女</van-radio>
            </van-radio-group>
          </div>
          <!-- 手机号 -->
          <div class="formItem">
            <van-field
              v-model="form.mobile"
              label="手机号"
              type="tel"
              maxlength="11"
              placeholder="请输入手机号"
              required
            />
          </div>
          <!-- 校友专属字段 -->
          <div class="formItem" v-if="addFields.graduate_year&&form.identity=='校友'">
            <van-field
              v-model="form.year"
              label="入学年份"
              type="tel"
              placeholder="请输入入学年份"
              :required="requiredField.graduate_year"
            />
          </div>
          <div class="formItem" v-if="addFields.biye_year&&form.identity=='校友'">
            <van-field
              v-model="form.biye_year"
              label="毕业年份"
              type="tel"
              placeholder="请输入毕业年份"
              :required="requiredField.biye_year"
            />
          </div>
          <div class="formItem" v-if="addFields.graduate_class&&form.identity=='校友'">
            <van-field
              v-model="form.class"
              label="毕业班级"
              placeholder="请输入毕业班级"
              :required="requiredField.graduate_class"
            />
          </div>
          <!-- 是否开发票 -->
          <div class="invoiceLine">
            <div class="itemLabel invoiceLabel">是否开发票</div>
            <van-radio-group v-model="form.isInvoice" direction="horizontal">
              <van-radio name="0" checked-color="#b8211a" icon-size="30rem">否</van-radio>
              <van-radio name="1" checked-color="#b8211a" icon-size="30rem">是</van-radio>
            </van-radio-group>
          </div>
          <!-- 身份证 -->
          <div class="formItem">
            <van-field
              v-model="form.IDNo"
              label="身份证号码"
              maxlength="18"
              placeholder="请输入身份证号码"
              :required="!!requiredField.idcard||form.isInvoice=='1'"
            />
          </div>
          <!-- 工作单位 -->
          <div class="formItem" v-if="addFields.work_unit">
            <van-field
              v-model="form.workUnit"
              label="工作单位"
              placeholder="请输入工作单位"
              :required="requiredField.work_unit"
            />
          </div>
          <!-- 职务职称 -->
          <div class="formItem" v-if="addFields.jobs">
            <van-field
              v-model="form.duties"
              label="职务/职称"
              placeholder="请输入职务/职称"
              :required="requiredField.jobs"
            />
          </div>
          <!-- 所在地区 -->
          <div class="formItem" v-if="addFields.area">
            <van-field
              v-model="form.area"
              label="所在地区"
              placeholder="请输入所在地区"
              :required="requiredField.area"
            />
          </div>
          <!-- 通讯地址 -->
          <div class="formItem" v-if="addFields.address">
            <van-field
              v-model="form.address"
              label="通讯地址"
              placeholder="请输入通讯地址"
              :required="requiredField.address"
            />
          </div>
          <!-- 出生年月 -->
          <div class="formItem" v-if="addFields.birthday">
            <van-field
              readonly
              clickable
              :value="form.date"
              label="出生年月"
              placeholder="点击选择出生年月"
              @click="showBirthPicker = true"
              :required="!!requiredField.birthday"
            />
            <van-popup v-model="showBirthPicker" position="bottom">
              <van-datetime-picker
                v-model="birthDate"
                type="year-month"
                title="选择年月"
                :min-date="minBirthDate"
                :max-date="maxDate"
                :formatter="formatter"
                @confirm="chooseBirthDate"
                @cancel="showBirthPicker = false"
              />
            </van-popup>
          </div>
          <!-- 邮箱 -->
          <div class="formItem" v-if="addFields.email">
            <van-field
              v-model="form.email"
              label="邮箱"
              placeholder="请输入邮箱"
              :required="requiredField.email"
            />
          </div>
          <!-- 捐赠寄语 -->
          <div class="formItem textareaClass">
            <div class="itemLabel" style="padding-left: 8rem;">捐赠寄语</div>
            <van-field
              v-model="form.message"
              type="textarea"
              label=""
              label-width="0"
              placeholder="填写捐赠寄语"
              maxlength="150"
            />
          </div>
          <!-- 捐赠时间 -->
          <div class="formItem">
            <van-field
              readonly
              clickable
              required
              :value="form.donate_date"
              label="捐赠时间"
              placeholder="请选择捐赠时间"
              @click="showDonateDatePicker = true"
            />
            <van-popup v-model="showDonateDatePicker" position="bottom">
              <van-datetime-picker
                v-model="donateDate"
                type="date"
                title="选择捐赠时间"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="chooseDonateDate"
                @cancel="showDonateDatePicker = false"
              />
            </van-popup>
          </div>
          <!-- 支付凭证 -->
          <div class="formItem voucherItem">
            <div class="itemLabel">支付凭证<span class="star">*</span></div>
            <div class="voucherTip">请上传转账/支付截图，仅支持 jpg/png 等图片，单张不超过 5MB</div>
            <van-uploader v-model="form.fileList" :after-read="afterRead" :max-count="1" :max-size="5*1024*1024" @oversize="onOversize">
              <div class="uploadBox">
                <van-icon name="plus" size="22rem" />
                <span>上传凭证</span>
              </div>
            </van-uploader>
          </div>
        </div>

        <div class="popupFooter">
          <div :class="isSubmit?'submitBtn submiting':'submitBtn'" @click="submitOffline">{{btnText}}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {getOffLineDonateList,getProjectDonateInfo,submitOfflineDonate,uploadImage} from '@/api/index.js'
export default {
  name: 'offLineList',

  data() {
    return {
      projectId:"",
      keywords: "",
      //tab栏
      tabList:[
        {id:'time',name:"按时间"},
        {id:'money',name:"按捐款金额"},
      ],
      activeTab:'time',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      //分页信息
      pageIndex:0,
      totalNum:50,
      allNum:0,
      totalMoney:0,
      defaultImage: require('@/assets/avatar.png'),

      // ============ 线下捐赠提交 ============
      showForm:false,
      isSubmit:false,
      uploading:false,
      btnText:"提交",
      form:{
        money:"",        //金额
        identity:"",     //身份
        name:"",         //姓名(或团体)
        sex:"",          //性别
        mobile:"",       //手机号
        year:"",         //入学年份
        biye_year:"",    //毕业年份
        class:"",        //毕业班级
        workUnit:"",     //工作单位
        duties:"",       //职务/职称
        area:"",         //所在地区
        address:"",      //通讯地址
        IDNo:"",         //身份证号码
        date:"",         //出生年月
        email:"",        //邮箱
        message:"",      //捐赠寄语
        isInvoice:"0",   //是否需要发票
        donate_date:"",  //捐赠时间
        pay_voucher:"",  //支付凭证图片URL
        fileList:[],     //上传组件列表
      },
      addFields:{},      //需要展示哪些字段（与实名捐赠一致）
      requiredField:{},  //哪些字段必填（与实名捐赠一致）
      showIdentityPicker:false,
      showBirthPicker:false,
      showDonateDatePicker:false,
      birthDate:new Date(2010,0,1),
      donateDate:new Date(),
      minBirthDate:new Date(1900,0,1),
      minDate:new Date(1950,0,1),
      maxDate:new Date(),
      indentityList: ["校友", "教职工", "家长", "其他"],
    };
  },

  mounted() {
    this.projectId = this.$route.query.id
  },

  methods: {
    //获取列表数据
    async getList(){
      let params ={
        username:this.keywords,
        sort_type:this.activeTab,
        page:this.pageIndex,
        item_id:this.projectId,
      }
      const res = await getOffLineDonateList(params)
      if(res.status==200){
        this.allNum = res.data.all_num
        this.totalNum = res.data.total
        this.totalMoney = res.data.total_money
        this.list=[...this.list,...res.data.data]
        this.refreshing = false
        this.loading = false
      }else{
        this.$toast(res.err_msg)
      }
    },
    //切换tab
    changeTab(id){
      this.activeTab = id
      this.list = [];
      this.pageIndex = 1;
      this.getList();
    },
    //搜索事件
    onSearch() {
      this.list = [];
      this.pageIndex = 1;
      this.getList();
    },
    // 获取列表数据
    onLoad() {
      if (this.list.length < this.totalNum) {
        console.log(this.pageIndex, "第几页");
        this.pageIndex += 1;
        this.getList();
      } else {
        this.finished = true;
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageIndex = 1;
      this.list = [];
      this.getList();
    },
     //去往详情页面
     goDetail(id){
      this.$router.push({ path:`/project/projectDetail?id=${id}`})
    },

    // ============ 线下捐赠提交相关 ============
    // 日期格式化 YYYY-MM-DD
    formatDate(d){
      const y = d.getFullYear()
      const m = (d.getMonth()+1).toString().padStart(2,'0')
      const day = d.getDate().toString().padStart(2,'0')
      return `${y}-${m}-${day}`
    },
    // 年月格式化 YYYY年MM月
    formatMonth(d){
      const y = d.getFullYear()
      const m = (d.getMonth()+1).toString().padStart(2,'0')
      return `${y}年${m}月`
    },
    // 未登录时跳登录页
    toLogin(msg){
      this.$toast(msg || '请先登录')
      setTimeout(() => {
        if (localStorage.getItem('isWechat') == 1) {
          this.$router.push({ path: "/wechatLogin" })
        } else {
          this.$router.push({ path: "/login" })
        }
      }, 800)
    },
    // 打开提交弹窗
    async openForm(){
      const token = localStorage.getItem('token') || sessionStorage.getItem('token')
      if(!token){
        this.toLogin('请先登录后再提交线下捐赠')
        return
      }
      if(!this.form.donate_date){
        this.form.donate_date = this.formatDate(new Date())
        this.donateDate = new Date()
      }
      this.showForm = true
      this.getDonateInfo()
    },
    // 关闭弹窗
    closeForm(reset){
      this.showForm = false
      if(reset){
        this.resetForm()
      }
    },
    resetForm(){
      this.form = {
        money:"", identity:"", name:"", sex:"", mobile:"", year:"", biye_year:"", class:"",
        workUnit:"", duties:"", area:"", address:"", IDNo:"", date:"", email:"", message:"",
        isInvoice:"0", donate_date:"", pay_voucher:"", fileList:[]
      }
    },
    // 获取项目的捐赠字段配置（与实名捐赠同一接口，保证字段一致）
    async getDonateInfo(){
      const res = await getProjectDonateInfo(this.projectId)
      if(res && res.status == 200){
        this.addFields = res.data.add_field || {}
        this.requiredField = res.data.required_field || {}
        if(res.data.tpl_message && !this.form.message){
          this.form.message = res.data.tpl_message
        }
      }else{
        // 兜底：接口异常时按实名捐赠全字段展示，仅姓名/手机号/身份必填
        this.addFields = {
          name:true, sex:true, mobile:true, identity:true, graduate_year:true,
          biye_year:true, graduate_class:true, work_unit:true, jobs:true,
          area:true, address:true, idcard:true, birthday:true, email:true
        }
        this.requiredField = { name:true, mobile:true }
        if(res && (res.err_code == 10001 || res.err_code == 10002 || res.err_code == 31014)){
          this.toLogin(res.err_msg || '请先登录')
        }
      }
    },
    // 选择身份
    chooseIdentity(value){
      this.form.identity = value
      this.showIdentityPicker = false
    },
    // 年月格式化（picker 展示）
    formatter(type, val){
      if (type === "year") return `${val}年`
      if (type === "month") return `${val}月`
      return val
    },
    // 选择出生年月
    chooseBirthDate(date){
      this.form.date = this.formatMonth(date)
      this.showBirthPicker = false
    },
    // 选择捐赠时间
    chooseDonateDate(date){
      this.form.donate_date = this.formatDate(date)
      this.showDonateDatePicker = false
    },
    // 图片超出大小
    onOversize(){
      this.$toast('图片大小不能超过 5MB')
    },
    // 支付凭证上传
    async afterRead(item){
      const file = Array.isArray(item) ? item[0] : item
      if(!file || !file.file) return
      if(this.uploading){
        this.$toast('凭证上传中，请稍候')
        return
      }
      const fd = new FormData()
      fd.append('file', file.file)
      this.uploading = true
      file.status = 'uploading'
      file.message = '上传中...'
      const res = await uploadImage(fd)
      this.uploading = false
      if(res && res.status == 200 && res.data && res.data.url){
        file.status = 'done'
        file.message = ''
        file.url = res.data.url
        this.form.pay_voucher = res.data.url
      }else{
        this.$toast((res && res.err_msg) || '上传失败，请重试')
        this.form.pay_voucher = ''
        this.form.fileList = this.form.fileList.filter(f => f !== file)
      }
    },
    // 提交
    async submitOffline(){
      if(this.isSubmit) return
      const f = this.form
      if(!f.money || Number(f.money) <= 0) return this.$toast('请填写正确的捐赠金额')
      if(!f.identity) return this.$toast('请选择身份')
      if(!f.name.trim()) return this.$toast('请填写姓名、团体')
      if(this.addFields.sex && this.requiredField.sex && !f.sex) return this.$toast('请选择性别')
      if(!f.mobile.trim()) return this.$toast('请填写手机号')
      if(this.addFields.graduate_year && f.identity=='校友' && this.requiredField.graduate_year && !f.year.trim()) return this.$toast('请填写入学年份')
      if(this.addFields.biye_year && f.identity=='校友' && this.requiredField.biye_year && !f.biye_year.trim()) return this.$toast('请填写毕业年份')
      if(this.addFields.graduate_class && f.identity=='校友' && this.requiredField.graduate_class && !f.class.trim()) return this.$toast('请填写毕业班级')
      if((this.requiredField.idcard || f.isInvoice == '1') && !f.IDNo.trim()) return this.$toast('请填写身份证号码')
      if(this.addFields.work_unit && this.requiredField.work_unit && !f.workUnit.trim()) return this.$toast('请填写工作单位')
      if(this.addFields.jobs && this.requiredField.jobs && !f.duties.trim()) return this.$toast('请填写职务/职称')
      if(this.addFields.area && this.requiredField.area && !f.area.trim()) return this.$toast('请填写所在地区')
      if(this.addFields.address && this.requiredField.address && !f.address.trim()) return this.$toast('请填写通讯地址')
      if(this.addFields.birthday && this.requiredField.birthday && !f.date) return this.$toast('请选择出生年月')
      if(this.addFields.email && this.requiredField.email && !f.email.trim()) return this.$toast('请填写邮箱')
      if(!f.donate_date) return this.$toast('请选择捐赠时间')
      if(this.uploading) return this.$toast('凭证图片上传中，请稍候')
      if(!f.pay_voucher) return this.$toast('请上传支付凭证')

      const params = {
        item_id: this.projectId,
        money: f.money,
        identity: f.identity,
        name: f.name,
        sex: f.sex,
        mobile: f.mobile,
        graduate_year: f.year,
        biye_year: f.biye_year,
        graduate_class: f.class,
        work_unit: f.workUnit,
        jobs: f.duties,
        area: f.area,
        address: f.address,
        id_card: f.IDNo,
        birthday: f.date,
        email: f.email,
        message: f.message,
        need_invoice: f.isInvoice,
        donate_date: f.donate_date,
        pay_voucher: f.pay_voucher,
      }

      this.isSubmit = true
      this.btnText = "提交中..."
      const res = await submitOfflineDonate(params)
      this.isSubmit = false
      this.btnText = "提交"
      if(!res) return
      if(res.status == 200){
        this.$toast('提交成功，等待管理员审核')
        this.closeForm(true)
        this.onRefresh()
      }else{
        this.$toast(res.err_msg || '提交失败')
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.projectBox {
  height: 250rem;
  overflow: hidden;
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
}
.searchLine{
  display: flex;
  align-items: center;
}
::v-deep .van-field__left-icon .van-icon {
  color: #b8211a !important;
  font-weight: 700;
}

::v-deep .van-search {
  padding: 45rem 40rem 30rem;
  width: 360rem;
}

::v-deep .van-search__content {
  background: #fff;
}
.showNum{
  flex:1;
  padding-right: 40rem;
  font-size:28rem;
  text-align: right;
  font-weight: 600;
}
.tabBox{
  display: flex;
  width: 670rem;
  margin:0 auto;
  font-size: 26rem;
  font-weight: 700;
  border-radius: 8rem;
  border: 1px solid #b8211a;
  .tabItem{
    width: 50%;
    height: 72rem;
    line-height: 72rem;
    text-align: center;
  }
  .activeTab{
    color:#fff;
    border-radius: 8rem;
    background-color: #b8211a;
  }
}
.listBox {
  width: 100%;
  margin-top: 250rem;
  padding: 45rem 40rem 200rem;

  .projectItem {
    width: 100%;
    padding: 30rem 0;
    border-bottom: 1px solid #e7e7e7;

    .projectDetail {
      display: flex;

      .imgBox {
        width: 110rem;
        height: 110rem;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 55rem;
        margin-right: 30rem;

        .coverImg {
          width: 100%;
        }
      }

      .contentBox {
        flex: 1;
        padding:10rem 0;
        .itemTitle {
          width: 100%;
          font-size: 26rem;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          /*行数*/
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin-bottom: 10rem;
          font-weight: 600;
        }

        .itemDis {
          width: 100%;
          font-size: 24rem;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          /*行数*/
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin-bottom: 18rem;
          line-height: 38rem;
        }

        .itemNum {
          display: flex;
          justify-content: space-between;

          .itemNumLeft {
            display: flex;
            align-items: center;

            .doneMoney {
              width: 48rem;
              height: 30rem;
              text-align: center;
              line-height: 30rem;
              border-radius: 8rem;
              color: #f79d01;
              font-size: 18rem;
              border: 1rem solid #f79d01;
              margin-right: 10rem;
            }
          }

          .moneyNum {
            font-size: 24rem;
            color: #3c3c3c;
            font-weight: 600;
          }

          
        }
      }
    }
  }
}
.timeBox{
  font-size: 22rem;
  color: #333;
  padding-top: 10rem;
}
.colorNum {
  color: #b8211a;
}

/* ============ 线下捐赠提交入口 ============ */
.submitBar{
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: rgba(255,255,255,0.96);
  box-shadow: 0 -2rem 12rem rgba(0,0,0,0.06);
  padding: 20rem 40rem calc(20rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(20rem + env(safe-area-inset-bottom));
  box-sizing: border-box;
  z-index: 20;
  .submitBarBtn{
    width: 100%;
    height: 88rem;
    line-height: 88rem;
    text-align: center;
    border-radius: 44rem;
    background-color: #b8211a;
    color: #fff;
    font-size: 30rem;
    font-weight: 600;
  }
}

/* ============ 提交弹窗 ============ */
.formPopup{
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;

  .popupHeader{
    flex: none;
    height: 96rem;
    line-height: 96rem;
    text-align: center;
    position: relative;
    border-bottom: 1px solid #f0f0f0;
    .popupTitle{
      font-size: 32rem;
      font-weight: 700;
      color: #121212;
    }
    .popupClose{
      position: absolute;
      right: 32rem;
      top: 50%;
      transform: translateY(-50%);
      font-size: 36rem;
      color: #999;
      padding: 10rem;
    }
  }

  .popupBody{
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 20rem 40rem 40rem;
  }

  .popupFooter{
    flex: none;
    padding: 20rem 40rem calc(20rem + constant(safe-area-inset-bottom));
    padding-bottom: calc(20rem + env(safe-area-inset-bottom));
    border-top: 1px solid #f0f0f0;
  }

  .formItem {
    border-bottom: 1px solid #e7e7e7;
    padding: 10rem 0;
    margin-bottom: 10rem;
  }
  .formItem:last-child {
    border-bottom: 0;
  }

  ::v-deep .van-field {
    padding: 20rem 60rem 20rem 0;
  }
  ::v-deep .van-field__label {
    width: 180rem;
    font-size: 26rem;
    font-weight: 700;
    color: #000;
    padding-left: 8rem;
  }
  ::v-deep .van-field__control {
    font-size: 24rem;
    color: #333333;
  }
  ::v-deep .van-cell {
    line-height: 35rem;
  }
  ::v-deep .van-radio__label {
    font-size: 26rem;
  }

  .itemLabel {
    font-size: 26rem;
    font-weight: 700;
    color: #000;
    margin-top: 20rem;
    padding-left: 8rem;
  }

  .sexItem {
    display: flex;
    align-items: center;
    padding: 20rem 0;
  }
  .sexLabel {
    margin-top: 0;
    width: 180rem;
  }

  .textareaClass ::v-deep .van-field {
    border: 1rem solid #e7e7e7;
    padding-left: 20rem;
    margin-top: 20rem;
  }

  .invoiceLine{
    display: flex;
    align-items: center;
    padding: 30rem 0 20rem;
    .invoiceLabel{
      margin-top: 0;
      margin-right: 20rem;
    }
  }

  .voucherItem{
    padding-bottom: 30rem;
  }
  .voucherTip{
    font-size: 22rem;
    color: #999;
    padding: 10rem 8rem 20rem;
    line-height: 32rem;
  }
  .uploadBox{
    width: 160rem;
    height: 160rem;
    border: 1rem dashed #d9d9d9;
    border-radius: 10rem;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 22rem;
    span{
      margin-top: 10rem;
    }
  }
  .star{
    color: #ee0a24;
    margin-left: 6rem;
  }

  .submitBtn {
    margin: 0 auto;
    text-align: center;
    line-height: 88rem;
    border-radius: 44rem;
    color: #fff;
    font-size: 30rem;
    font-weight: 600;
    background-color: #b8211a;
  }
  .submiting{
    background-color: #666;
  }
}
</style>
